/* Pro sample request: pick a formula, then three steps.

   LOCAL MOCK. There is no endpoint behind this. The final step swaps the form
   for a confirmation panel and logs the payload; wiring it to a real form
   service is a live-site job, not a mockup one.

   Progressive enhancement, deliberately. With JS off the fieldsets are all
   visible and the form is one long page that still reads and still tabs in
   order, and the pickers are ordinary checkboxes that still submit. The script
   is what collapses the form into steps and keeps the running summary, so
   nobody who blocks scripts gets a dead page.

   The pickers live up in the kit grid, OUTSIDE the <form>, because that grid is
   the media and the media should be the control rather than a second smaller
   copy of it further down. They still submit with the form: each one carries
   form="sample-form", which is what that attribute is for. */
(function () {
  'use strict';

  var form = document.getElementById('sample-form');
  if (!form) return;

  var picks = Array.prototype.slice.call(
    document.querySelectorAll('input[name="formulas"]'));

  /* "At least one of these five" is not expressible in native constraint
     validation. Marking every box required demands all five; marking one
     required demands that specific one. So this one rule is checked by hand,
     and it is checked in the two places a person can run into it: leaving the
     first step, and submitting. */
  function chosen() {
    return picks.filter(function (p) { return p.checked; })
                .map(function (p) { return p.dataset.name || p.value; });
  }

  var summary = document.getElementById('pick-summary');
  var mirror = document.getElementById('form-picks');
  var pickError = document.getElementById('pick-error');

  function words(list) {
    if (list.length === 1) return list[0];
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }

  function render() {
    var list = chosen();
    if (summary) {
      summary.textContent = list.length
        ? words(list)
        : 'Nothing selected yet.';
      summary.classList.toggle('is-empty', !list.length);
    }
    if (mirror) {
      mirror.textContent = list.length
        ? words(list) + (list.length === 1 ? '' : ', ' + list.length + ' cartridges')
        : 'Nothing selected yet.';
      mirror.classList.toggle('is-empty', !list.length);
    }
    if (list.length && pickError) pickError.hidden = true;
  }

  picks.forEach(function (p) { p.addEventListener('change', render); });

  /* Arriving from a product page with ?pick=<slug> ticks that formula on the way
     in. Without it the reader spends a page deciding which one they want, then
     lands on a five-way picker and has to decide again, which is the difference
     between a link and a flow.

     Only ids that already exist are honoured, so a stale or hand-edited slug is
     ignored rather than throwing. Multiple picks are allowed, since someone may
     have opened two product pages. */
  var wanted = (location.search.match(/[?&]pick=([^&]*)/) || [])[1];
  if (wanted) {
    wanted.split(',').forEach(function (slug) {
      var key = slug.replace(/[^a-z-]/gi, '');
      var box = document.getElementById('nbn-pick-' + key) || document.getElementById('pick-' + key);
      if (box && !box.checked) box.checked = true;
    });
  }

  render();

  function requirePick() {
    if (chosen().length) return true;
    if (pickError) pickError.hidden = false;
    var kit = document.getElementById('kit');
    if (kit) kit.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (picks[0]) picks[0].focus({ preventScroll: true });
    return false;
  }

  /* ------------------------------------------------------------------ steps */

  var steps = Array.prototype.slice.call(form.querySelectorAll('.fstep'));
  if (steps.length < 2) return;

  var counter = form.querySelector('.fcount');
  var bar = form.querySelector('.fbar span');
  var done = document.getElementById('sample-done');
  var at = 0;

  /* Native validity, so the browser supplies the messages and the required
     semantics rather than a bespoke half-implementation of both. */
  function valid(step) {
    var fields = step.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) {
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  function show(n, focus) {
    at = n;
    steps.forEach(function (s, i) { s.hidden = i !== n; });
    if (counter) counter.textContent = 'Step ' + (n + 1) + ' of ' + steps.length;
    if (bar) bar.style.width = ((n + 1) / steps.length * 100) + '%';
    if (focus) {
      /* Move the caret to the top of the new step. The legend takes focus
         rather than the first input so a screen reader announces which step
         this is before it starts reading fields. */
      var h = steps[n].querySelector('legend');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      var top = form.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  form.addEventListener('click', function (e) {
    var next = e.target.closest('[data-next]');
    var back = e.target.closest('[data-back]');
    if (next) {
      e.preventDefault();
      if (at === 0 && !requirePick()) return;
      if (valid(steps[at])) show(Math.min(at + 1, steps.length - 1), true);
    } else if (back) {
      e.preventDefault();
      show(Math.max(at - 1, 0), true);
    }
  });

  /* Live: this form IS a Shopify contact form (converted at the end of this file).
     Shopify's captcha script binds hCaptcha to it when a field is focused, and on
     submit it adds its token and posts. So cancel the submit only when it must not
     go; a valid one is left alone. (25 Sep 2026: a script-built form sent with
     form.submit() fired no submit event, got no token, and Shopify rejected every
     request with "Missing CAPTCHA token".) */
  form.addEventListener('submit', function (e) {
    if (!valid(steps[at]) || !requirePick()) { e.preventDefault(); return; }
    var fd = new FormData(form), data = {};
    fd.forEach(function (v, k) { if (k !== 'formulas') data[k] = v; });
    data.formulas = fd.getAll('formulas');       // a multi-value field, not a scalar
    var club = document.getElementById('caulk_club');
    data.caulk_club = !!(club && club.checked);  // a real boolean, not "yes"/absent
    /* Write the request into the form's hidden contact[...] fields. Shopify emails
       every contact[...] field to the store's contact address, headed "Free sample
       request: ...", and that email is the record (owner, 25 Sep 2026: "it shouldnt
       go to google forms"). */
    var params = new URLSearchParams(location.search);
    var src = params.get('r') || params.get('ref') || params.get('utm_source') || 'direct';
    var rows = [
      ['Free sample request', data.formulas.join(', ')],
      ['Company', data.company || ''],
      ['Trade', data.trade || ''],
      ['Cartridges a week', data.volume || ''],
      ['Buys caulk at', (data.shop_channel || '') + (data.shop_name ? ' (' + data.shop_name + ')' : '')],
      ['Current brand', data.current_brand || ''],
      ['Ship to', [data.address1, data.address2, data.city, data.state, data.zip].filter(Boolean).join(', ')],
      ['Best way to reach', (data.contact_pref || '') + (data.social ? ' ' + data.social : '')],
      ['Heard about it', data.heard || ''],
      ['Joined Caulk Club for the $5 code', data.caulk_club ? 'yes' : 'no'],
      ['Source', 'pro-samples ' + src]
    ];
    function field(name, value) {
      var i = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = name; form.appendChild(i); }
      i.value = value;
    }
    field('contact[name]', ((data.first_name || '') + ' ' + (data.last_name || '')).trim());
    field('contact[email]', data.email || '');
    field('contact[phone]', data.phone || '');
    rows.forEach(function (r) { field('contact[' + r[0] + ']', r[1]); });
    field('contact[body]', rows.map(function (r) { return r[0] + ': ' + r[1]; }).join('\n'));
    var back = new URLSearchParams(location.search);
    back.set('sent', data.formulas.join('|'));
    if (data.caulk_club) back.set('joined', '1'); else back.delete('joined');
    field('return_to', location.pathname + '?' + back.toString());
    try { sessionStorage.setItem('nbnSampleSent', JSON.stringify({ f: data.formulas, j: data.caulk_club })); } catch (err) {}
    var sendBtn = form.querySelector('button[type="submit"]');
    if (sendBtn) sendBtn.textContent = 'Sending...';
    return;   /* not cancelled: Shopify's captcha takes the event and posts to /contact */
    if (done) {
      var what = done.querySelector('#done-picks');
      if (what) what.textContent = words(chosen());
      /* The $5 line only appears if they actually joined. Showing it either way
         would promise a code to somebody who declined it. */
      var clubLine = document.getElementById('done-club');
      if (clubLine) clubLine.hidden = !data.caulk_club;
      form.hidden = true;
      done.hidden = false;
      done.setAttribute('tabindex', '-1');
      done.focus();
    }
  });

  /* Enter inside a step advances instead of submitting the whole form early.
     Without this, a browser fires submit from step one and the request goes
     out with two thirds of the fields empty. */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target.tagName === 'TEXTAREA' || e.target.type === 'submit') return;
    if (at < steps.length - 1) {
      e.preventDefault();
      if (at === 0 && !requirePick()) return;
      if (valid(steps[at])) show(at + 1, true);
    }
  });

  /* Make the request form a real Shopify contact form: posts to /contact with
     form_type=contact, which is exactly what Shopify's captcha script looks for
     (form[action*='/contact'] input[name='form_type'][value='contact']). It must
     exist before the visitor focuses a field, which is when the captcha binds. */
  form.setAttribute('method', 'post');
  form.setAttribute('action', '/contact#contact_form');
  form.setAttribute('accept-charset', 'UTF-8');
  [['form_type', 'contact'], ['utf8', '\u2713']].forEach(function (kv) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
    form.insertBefore(i, form.firstChild);
  });

  form.classList.add('is-stepped');
  show(0, false);

  /* Back from Shopify's contact form: it returns here with our return_to (sent=...)
     or, if it ignored return_to, with contact_posted=true. Either way the request
     is in, so show the thank-you instead of an empty form. */
  var q = new URLSearchParams(location.search);
  if (done && (q.has('sent') || q.get('contact_posted') === 'true')) {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('nbnSampleSent') || '{}'); } catch (err) {}
    var sentList = q.has('sent') ? q.get('sent').split('|').filter(Boolean) : (saved.f || []);
    var joined = q.get('joined') === '1' || !!saved.j;
    var what = done.querySelector('#done-picks');
    if (what) what.textContent = sentList.length ? words(sentList) : 'your sample';
    var clubLine = document.getElementById('done-club');
    if (clubLine) clubLine.hidden = !joined;
    form.hidden = true;
    done.hidden = false;
    done.setAttribute('tabindex', '-1');
    setTimeout(function () { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }, 60);
    try { sessionStorage.removeItem('nbnSampleSent'); } catch (err) {}
  }
}());

/* ---------------------------------------------------------------------------
   Caulk Club member mode. Added 25 Sep 2026, owner: "I want all members to
   receive it."

   The page is written for the trade: Company, a trade list and a consent line
   ("I caulk for a living ...") are required, and the rules say trade
   professionals only. The Caulk Club email links here with club=1, and on that
   visit only the trade-only parts are relaxed so any member can claim honestly,
   homeowners included. Without club=1 the public page is exactly as before.

   Appended to nbn-samples.js by _live/build_live.py, so a rebuild keeps it.
   Every edit is keyed to text or ids already on the page and fails quietly: if
   a line moves, that line simply keeps its public wording.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (new URLSearchParams(location.search).get('club') !== '1') return;
  var form = document.getElementById('sample-form');
  if (!form) return;
  document.documentElement.classList.add('nbn-club-mode');

  /* Replace a phrase inside text nodes only, so markup around it (the picked
     formulas in the thank-you, the required star on a label) survives. */
  function retext(root, from, to) {
    if (!root) return false;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, hit = false;
    while ((n = walk.nextNode())) {
      var flat = n.nodeValue.replace(/\s+/g, ' ');
      if (flat.indexOf(from) !== -1) { n.nodeValue = flat.replace(from, to); hit = true; }
    }
    return hit;
  }
  function hideItem(root, startsWith) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('li'), function (li) {
      if (li.textContent.replace(/\s+/g, ' ').trim().indexOf(startsWith) === 0) li.style.display = 'none';
    });
  }
  function addOption(select, label, selectIt) {
    if (!select) return;
    var o = document.createElement('option');
    o.textContent = label;
    var first = select.querySelector('option[disabled]');
    select.insertBefore(o, first ? first.nextSibling : select.firstChild);
    if (selectIt) select.value = label;
  }

  var how = document.getElementById('nbn-how');
  retext(how, 'we ask what trade you are in and how much caulk you go through, because that is what tells us the sample is going to a job and not a drawer.',
              'we ask a little about you and the job, so the right cartridge goes to the right place.');
  retext(how, 'to your business address.', 'to your address.');
  retext(how, ' Join the Caulk Club on the way through and there is $5 off your first order too.', '');

  var req = document.getElementById('nbn-request');
  retext(req, 'Trade professionals only, one request per company.',
              'Open to every Caulk Club member, trade or not. One request per member.');
  retext(req, 'This is the part that decides it. We send to people who are running cartridges every week, and the volume figure is how we tell.',
              'Homeowners are welcome. Leave the company blank if it is just you.');
  retext(req, 'A business address, in the 48 contiguous states.', 'Any street address in the 48 contiguous states.');
  retext(req, 'I caulk for a living and I am requesting this sample for my business.',
              'I am a Caulk Club member requesting this sample.');
  retext(req, 'We check the company, then it ships.', 'We check the request, then it ships.');

  /* The legend and labels: the steps focus the legend, so only its words change. */
  var work = form.querySelectorAll('.fstep legend');
  Array.prototype.forEach.call(work, function (lg) { retext(lg, 'Your work', 'You and the job'); });
  retext(form.querySelector('label[for="nbn-trade"]'), 'Your trade', 'What best describes you');

  /* Company becomes optional; a blank one is recorded as a member request. */
  var company = document.getElementById('nbn-company');
  if (company) {
    company.required = false;
    company.placeholder = 'Leave blank if it is just you';
    var star = form.querySelector('label[for="nbn-company"] .nbn-req');
    if (star) { star.className = 'nbn-fhelp'; star.style.cssText = 'display:inline;text-transform:none;letter-spacing:0'; star.textContent = '(optional)'; }
    /* Capture on document, which always runs before the form's own submit handler
       reads the fields, in every engine. */
    document.addEventListener('submit', function (e) {
      if (e.target === form && !company.value.trim()) company.value = 'Caulk Club member';
    }, true);
  }
  addOption(document.getElementById('nbn-trade'), 'Homeowner or DIY', false);
  addOption(document.getElementById('nbn-heard'), 'The Caulk Club email', true);

  /* They are already members: the "join and get $5" block and its two rules go. */
  var club = form.querySelector('.nbn-club');
  if (club) club.style.display = 'none';

  var rules = document.querySelector('.nbn-terms-list');
  retext(rules, 'Trade professionals only. We check the company before anything ships.',
                'Open to Caulk Club members, trade or not. We check each request before anything ships.');
  retext(rules, 'One request per company and per shipping address.', 'One request per member and per shipping address.');
  retext(rules, 'Ships free to a business address in the 48 contiguous states.', 'Ships free to a street address in the 48 contiguous states.');
  hideItem(rules, 'The Caulk Club is optional.');
  hideItem(rules, 'The $5 code is one per company');
}());

/* ---------------------------------------------------------------------------
   When Shopify's captcha cannot load. Added 28 Sep 2026, owner: "yes add that
   to the page".

   Shopify guards this form with an invisible hCaptcha. An ad blocker, a privacy
   extension or a network filter can stop those scripts loading, and then
   Shopify swallows the Send click without a word: the button says Sending...
   and nothing happens. A Caulk Club member ran into a captcha he could not see
   on 25 Sep; most people in that spot simply leave.

   So this watches for two signs and, on either, puts a note under the Send
   button that points to sales@ with the request already written out:
     1. a captcha script fails to load, which is a blocker for certain;
     2. a valid Send that is still on the page 10 seconds later with no captcha
        puzzle open, which covers blockers that hang instead of failing.
   A puzzle on screen is left alone, and so is a request already on its way.

   Appended to nbn-samples.js by _live/build_live.py, after club mode, so a
   rebuild keeps it. It never cancels a submit, so it cannot stop a request
   that would have gone through.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';
  var form = document.getElementById('sample-form');
  if (!form) return;
  var btn = form.querySelector('button[type="submit"]');
  var label = btn ? btn.textContent : '';
  var TO = 'sales@newborncaulkguns.com';
  var blocked = false, note = null, timer = 0, leaving = false, watching = false;

  /* Load errors do not bubble, so catch them on the way down. Shopify's loader
     comes from cdn.shopify.com (storefront-forms-hcaptcha) and the captcha from
     js.hcaptcha.com; both carry hcaptcha in the address. */
  window.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'SCRIPT' && /hcaptcha/i.test(t.src || '')) {
      blocked = true;
      showNote(false);
    }
  }, true);

  /* hCaptcha keeps its puzzle in an iframe that stays hidden until it is needed. */
  function puzzleOpen() {
    return Array.prototype.some.call(document.querySelectorAll('iframe[src*="hcaptcha"]'), function (f) {
      return /frame=challenge/.test(f.src) && getComputedStyle(f).visibility === 'visible';
    });
  }

  /* The email arrives written out, so nobody types the request twice. After a
     Send the page has already put it into the contact[...] fields for Shopify;
     before one, it is read from the fields as they stand. */
  function mailto() {
    var el = form.elements, lines = [];
    function v(n) { var f = el[n]; return f && f.value ? String(f.value).trim() : ''; }
    if (v('contact[body]')) {
      [['Name', v('contact[name]')], ['Email', v('contact[email]')], ['Phone', v('contact[phone]')]]
        .forEach(function (r) { if (r[1]) lines.push(r[0] + ': ' + r[1]); });
      lines.push(v('contact[body]'));
    } else {
      var fd = new FormData(form), picked = fd.getAll('formulas');
      if (picked.length) lines.push('Free sample request: ' + picked.join(', '));
      [['first_name', 'First name'], ['last_name', 'Last name'], ['email', 'Email'], ['phone', 'Phone'],
       ['company', 'Company'], ['address1', 'Street'], ['address2', 'Suite or unit'], ['city', 'City'],
       ['state', 'State'], ['zip', 'ZIP']].forEach(function (k) {
        var x = fd.get(k[0]);
        if (x) lines.push(k[1] + ': ' + x);
      });
    }
    if (lines.length) lines.push('');
    lines.push('Sent by email because the form on the page would not go through.');
    return 'mailto:' + TO + '?subject=' + encodeURIComponent('Free sample request') +
      '&body=' + encodeURIComponent(lines.join('\r\n'));
  }

  function showNote(scroll) {
    if (!note) {
      note = document.createElement('p');
      note.id = 'sample-send-help';
      note.className = 'nbn-pick-error';     /* the page's own boxed note */
      note.setAttribute('role', 'alert');
      var nav = btn && btn.closest ? btn.closest('.nbn-fnav') : null;
      if (nav) nav.insertAdjacentElement('afterend', note); else form.appendChild(note);
    }
    var link = document.createElement('a');
    link.href = mailto();
    link.textContent = TO;
    link.addEventListener('click', function () { link.href = mailto(); });
    note.textContent = blocked
      ? 'Your browser is blocking the security check this form uses, so the request cannot be sent from this page. '
      : 'Not going through? Your browser may be blocking the security check this form uses. ';
    note.appendChild(document.createTextNode('An ad blocker or privacy extension is the usual cause. Email your request to '));
    note.appendChild(link);
    note.appendChild(document.createTextNode(' and we will take care of it.'));
    note.hidden = false;
    if (btn && btn.textContent !== label) btn.textContent = label;   /* so Send can be pressed again */
    if (scroll) note.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  form.addEventListener('submit', function () {
    /* The form's own handler runs first and relabels the button only for a
       complete, valid request; anything else is a missing field it has flagged. */
    if (!btn || btn.textContent !== 'Sending...') return;
    if (blocked) { showNote(true); return; }
    if (!watching) {
      watching = true;
      /* A request on its way starts a navigation, and beforeunload fires as it starts. */
      window.addEventListener('beforeunload', function () { leaving = true; });
    }
    leaving = false;
    clearTimeout(timer);
    (function check(wait) {
      timer = setTimeout(function () {
        if (leaving) return;
        if (puzzleOpen()) { check(3000); return; }
        showNote(true);
      }, wait);
    }(10000));
  });
}());
